import { styled } from '@nykaa/ui-components';

export const Loader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none;
  overscroll-behavior: none;
`;

export const Wrapper = styled.div`
  height: 100vh;
  position: relative;
  background-color: white;
`;

export const FindMyShadeButton = styled.button`
  display: none;
`;
